import { useEffect, useRef } from 'react';

/**
 * Tracks a previous value to allow for comparing prev props/state to current
 */
export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
